export function getAxisStyle(axisStyle) {
    return {
        defaultAxisStyle: getSingleAxisStyle(axisStyle.defaultAxisStyle),
        leftAxisStyle: getSingleAxisStyle(axisStyle.leftAxisStyle),
        rightAxisStyle: getSingleAxisStyle(axisStyle.rightAxisStyle),
        topAxisStyle: getSingleAxisStyle(axisStyle.topAxisStyle),
        bottomAxisStyle: getSingleAxisStyle(axisStyle.bottomAxisStyle)
    };
}

function getSingleAxisStyle(axisStyle) {
    return axisStyle || {};
}

export const defalutPoptipStyle = {
    visible: !0,
    position: "auto",
    padding: 8,
    titleStyle: {
        fontSize: 12,
        fontWeight: "bold",
        fill: "#4E5969"
    },
    contentStyle: {
        fontSize: 12,
        fill: "#4E5969"
    },
    panel: {
        visible: !0,
        fill: "#fff",
        stroke: "#ffffff",
        lineWidth: 0,
        cornerRadius: 3,
        shadowBlur: 12,
        shadowOffsetX: 0,
        shadowOffsetY: 4,
        shadowColor: "rgba(0, 0, 0, 0.1)",
        size: 0,
        space: 12
    }
};
//# sourceMappingURL=component.js.map
